import { MeDocument, useMeQuery, useUpdateNotificationsSettingMutation } from "../../../../graphql/generated/graphql";
import Loader from "../../../../components/common/status/Loader/Loader";
import { View } from "moti";
import CustomText from "../../../../components/common/general/CustomText/CustomText";
import CustomSwitch from "../../../../components/common/general/CustomSwitch/CustomSwitch";

function NotificationsSwitch() {
  const { data: meData, loading: meLoading, error: meError } = useMeQuery();
  const [updateNotificationsSetting] = useUpdateNotificationsSettingMutation({
    refetchQueries: [
      {
        query: MeDocument,
      },
    ],
  });

  const handleDailyEmailOptInPress = async () => {
    try {
      await updateNotificationsSetting({
        variables: {
          dailyEmailOptIn: !meData?.me?.dailyEmailOptIn,
        },
      });
    } catch (error) {
      console.error("failed", error);
    }
  };

  if (meError) {
    return (
      <View style={{ flex: 1, justifyContent: "center" }}>
        <CustomText
          style={{ color: "#E57373" }}
          text="There was an error fetching the user notifications. Please try again later."
        />
      </View>
    );
  }

  if (meLoading) {
    return <Loader />;
  }

  return <CustomSwitch value={meData?.me?.dailyEmailOptIn} onValueChange={handleDailyEmailOptInPress} />;
}

export default NotificationsSwitch;
